import { When } from './InlineIf';

export const IsIE = () => {
	return window.navigator.userAgent.indexOf('Trident') > -1;
};

export function FilterOut<T>(collection: T[], excluding: T[]): T[] {
	return collection.filter((item) => {
		return excluding.indexOf(item) === -1;
	});
}

export function GetObjectValues(object: object): any[] {
	return Object.keys(object).map((key) => (object as any)[key]);
}

export function NameOf<T>(prop: keyof T & string): string {
	return prop;
}

export function IsDefined<T>(a: T): a is Exclude<T, undefined> {
	return a !== undefined;
}

export function FlatMap<T, P>(arr: T[], projection: (member: T) => P[]): P[] {
	return arr.map(projection).reduce<P[]>((flatArr, values) => flatArr.concat(values), []);
}

export function IsArrayOf<T>(entity: any, memberIsOfType: (member: any) => member is T): entity is T[] {
	return IsDefined(entity) && entity instanceof Array && entity.every(memberIsOfType);
}

export { When };

export function Group<TGroup, T extends TGroup>(members: T[], belongsToGroup: (member: T, group: TGroup) => boolean) {
	const groupings: { group: TGroup; groupMembers: T[] }[] = [];

	members.forEach((member) => {
		// Fetch the grouping associated with the member
		const groupingForMember = groupings.find(({ group }) => belongsToGroup(member, group));

		if (groupingForMember !== undefined) {
			// If a grouping already exists, then append the member
			const { groupMembers } = groupingForMember;
			groupMembers.push(member);
		} else {
			// If a grouping does not exist, instantiate one (based on the member)
			const group: TGroup = member;
			groupings.push({ group, groupMembers: [member] });
		}
	});

	return groupings;
}
